export default "__VITE_ASSET__6jR54V1a__"